import * as tslib_1 from "tslib";
import { DomainOption } from 'owa-domain-option';
import { validateDomain } from 'owa-domain-option';
import { getPremiumUser } from 'owa-domain-option';
import { trace } from 'owa-trace';
var premiumDashboardDomainSubCategory = {
    key: 'personalemail',
    titleStringKey: 'options_premiumSubOption_PersonalEmail',
    options: [DomainOption],
    onSelected: function () {
        return loadDomainDashBoard();
    },
};
function loadDomainDashBoard() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var e_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, validateDomain()];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, getPremiumUser()];
                case 2:
                    _a.sent();
                    return [2 /*return*/, true];
                case 3:
                    e_1 = _a.sent();
                    trace.warn(e_1.message);
                    return [2 /*return*/, false];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export default premiumDashboardDomainSubCategory;
//# sourceMappingURL=PremiumDashboardDomainSubCategory.js.map